<template>
  <footer
    id="contact"
    class="footer"
  >
    <div class="content has-text-centered">
      <div class="block">
        <a
          href="mailto:contact@riceflake.com"
          target="_blank"
        >
          <b-icon
            :size="size"
            pack="far"
            icon="envelope"
            class="icon icon--envelope"
          />
        </a>
        <a
          href="https://github.com/Riceflake"
          target="_blank"
        >
          <b-icon
            :size="size"
            pack="fab"
            icon="github"
            class="icon icon--github"
          />
        </a>
        <a
          href="https://linkedin.com/in/riceflake"
          target="_blank"
        >
          <b-icon
            :size="size"
            pack="fab"
            icon="linkedin"
            class="icon icon--linkedin"
          />
        </a>
      </div>
      <p>
        Made by Franck Zhang © 2018
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    color: {
      type: String,
      default: 'has-text-grey-dark',
    },
    size: {
      type: String,
      default: 'is-large',
    },
  },
};
</script>
<style scoped lang="scss">

.footer {
  background-color: inherit;
  padding: 3rem 0;
}

.block > a:not(:last-child) {
  margin-right: 2em;
}

.icon {
  color: #999;
  transition: color 0.5s ease;
  display: inline-block;
  opacity: 0.9;

  &:hover {
    display: inline-block;
    transition: transform 0.5s;
    transform: translateY(-3px);
  }

  &--linkedin:hover {
    color: $linkedin;
  }

  &--github:hover {
    color: $github;
  }

  &--envelope:hover {
    color: $red;
  }
}
</style>
